module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@aws-amplify/api/~/axios/index.js
// module id = 399
// module chunks = 0